import React, { useState } from "react";
import { clearAllData } from "../utils/configBackup";

/**
 * ResetConfig — TAV POS
 *
 * Borra TODO el almacenamiento local del navegador y recarga la app.
 * Al reiniciar, App.js intenta recuperar la configuración desde
 * C:\Program Files\TAV\tavpos_config.json vía PHP local.
 * Si no existe el archivo → flujo de registro manual.
 */
const ResetConfig = ({
  setDeviceConfig,
  setProperty,
  setCurrentProperty,
  setIsConfigLoaded,
}) => {
  const [confirmando, setConfirmando] = useState(false);
  const [trabajando, setTrabajando]   = useState(false);
  const [exitoLimpieza, setExitoLimpieza] = useState(false);

  const handleConfirmar = async () => {
    setTrabajando(true);
    try {
      await clearAllData();
      // Mostrar mensaje de éxito brevemente antes de recargar
      setTrabajando(false);
      setExitoLimpieza(true);
      setTimeout(() => window.location.reload(), 1800);
    } catch (err) {
      console.error('[ResetConfig] Error limpiando datos:', err);
      setTrabajando(false);
      setConfirmando(false);
    }
  };

  if (exitoLimpieza) {
    return (
      <button className="admin-button" disabled style={{ background: '#28a745', color: '#fff' }}>
        <i className="bi bi-check-circle"></i> ¡Limpieza exitosa! Reiniciando…
      </button>
    );
  }

  if (trabajando) {
    return (
      <button className="admin-button" disabled>
        <i className="bi bi-arrow-repeat spin"></i> Limpiando…
      </button>
    );
  }

  if (confirmando) {
    return (
      <>
        <button
          className="admin-button reset-config-btn--hard"
          onClick={handleConfirmar}
        >
          <i className="bi bi-check-lg"></i> Confirmar limpieza
        </button>
        <button
          className="admin-button reset-config-btn--cancel"
          onClick={() => setConfirmando(false)}
        >
          <i className="bi bi-x"></i> Cancelar
        </button>
      </>
    );
  }

  return (
    <button
      className="admin-button reset-config-btn--soft"
      onClick={() => setConfirmando(true)}
      title="Borra todos los datos locales y recarga. La configuración se recupera automáticamente."
    >
      <i className="bi bi-arrow-counterclockwise"></i> Restablecer Configuración
    </button>
  );
};

export default ResetConfig;
